import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../auth.service';
import { DataServiceService } from '../data-service.service';
import { markHistoryDetailNavigation } from '../utils/history-navigation-utils';
import { getAdverseMediaTotalReturnedCount } from '../utils/adverse-media-utils';

@Component({
  selector: 'app-history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.scss']
})
export class HistoryComponent implements OnInit {

  searchTerm = ""
  isLoading: boolean = true
  userEmail: string;
  PEPuserHistory: any[] = []
  AlluserHistory: any[] = []
  NSLuserHistory: any[] = []
  NSLEntityHistory: any[] = []
  SanctionUserHistory: any[] = []
  EntityHistory: any[] = []
  CriminaluserHistory: any[] = []
  ReportUserHistory: any[] = []
  AdverseMediaReportHistory: any[] = []
  AdverseMediaDetailHistory: any[] = []
  BatchScanHistory: any[] = []

  noHistoryFound: boolean = false;
  isLoadingAdverseMediaDetail = false;
  isLoadingBatchScanReport = false;
  private mongoAdverseMediaHistory: any[] = [];

  constructor(private dataService: DataServiceService, private router: Router, private authService: AuthService) {
    this.userEmail = this.authService.getCurrentUser().email;
  }

  async ngOnInit() {
    const skipOnBack = localStorage.getItem("skipHistoryOnBack") === "true";
    const skipOnBackTs = Number(localStorage.getItem("skipHistoryOnBackTs") || "0");
    const skipOnBackValid = skipOnBack && Date.now() - skipOnBackTs < 60000;

    if (skipOnBack && !skipOnBackValid) {
      localStorage.removeItem("skipHistoryOnBack");
      localStorage.removeItem("skipHistoryOnBackTs");
      sessionStorage.removeItem("historyPageCache");
    }

    if (skipOnBackValid) {
      localStorage.removeItem("skipHistoryOnBack");
      localStorage.removeItem("skipHistoryOnBackTs");
      if (this.restoreFromCache()) {
        this.refreshAdverseMediaHistory();
        return;
      }
    }

    this.loadData()
      .then(() => {
        this.applyHistoryData();
      }, (err) => {
        this.isLoading = false;
        this.noHistoryFound = true
      })
      .catch((err) => {
        this.isLoading = false;
        this.noHistoryFound = true
      })

  }

  private applyHistoryData() {
    console.log('this.AlluserHistory', this.AlluserHistory);
    this.NSLuserHistory = this.AlluserHistory.filter(history => history['type'] == 'NSL')
    this.NSLEntityHistory = this.AlluserHistory.filter(history => history['type'] == 'NSL_ENTITY')
    this.SanctionUserHistory = this.AlluserHistory.filter(history => history['type'] == 'SANCTION')
    this.PEPuserHistory = this.AlluserHistory.filter(history => history['type'] == 'PEP')
    this.CriminaluserHistory = this.AlluserHistory.filter(history => history['type'] == 'CRIMINALS')
    this.ReportUserHistory = this.AlluserHistory.filter(history => history['type'] == 'REPORT')
    this.buildAdverseMediaHistories();
    this.EntityHistory = this.AlluserHistory.filter(history => history['isEntity'] == true)
    this.noHistoryFound =
      this.AlluserHistory.length <= 0 &&
      this.AdverseMediaReportHistory.length <= 0 &&
      this.AdverseMediaDetailHistory.length <= 0 &&
      this.BatchScanHistory.length <= 0;
    this.isLoading = false;
    console.log('this.ReportUserHistory', this.ReportUserHistory);
  }

  private cacheHistoryState() {
    sessionStorage.setItem(
      "historyPageCache",
      JSON.stringify({
        userEmail: this.userEmail,
        searchTerm: this.searchTerm,
        AlluserHistory: this.AlluserHistory,
        mongoAdverseMediaHistory: this.mongoAdverseMediaHistory,
        PEPuserHistory: this.PEPuserHistory,
        NSLuserHistory: this.NSLuserHistory,
        NSLEntityHistory: this.NSLEntityHistory,
        SanctionUserHistory: this.SanctionUserHistory,
        EntityHistory: this.EntityHistory,
        CriminaluserHistory: this.CriminaluserHistory,
        ReportUserHistory: this.ReportUserHistory,
        AdverseMediaReportHistory: this.AdverseMediaReportHistory,
        AdverseMediaDetailHistory: this.AdverseMediaDetailHistory,
        BatchScanHistory: this.BatchScanHistory,
        noHistoryFound: this.noHistoryFound,
      }),
    );
  }

  private restoreFromCache(): boolean {
    const raw = sessionStorage.getItem("historyPageCache");
    if (!raw) {
      return false;
    }

    try {
      const cache = JSON.parse(raw);
      if (cache.userEmail !== this.userEmail) {
        return false;
      }

      this.searchTerm = cache.searchTerm || "";
      this.AlluserHistory = cache.AlluserHistory || [];
      this.mongoAdverseMediaHistory = cache.mongoAdverseMediaHistory || [];
      this.PEPuserHistory = cache.PEPuserHistory || [];
      this.NSLuserHistory = cache.NSLuserHistory || [];
      this.NSLEntityHistory = cache.NSLEntityHistory || [];
      this.SanctionUserHistory = cache.SanctionUserHistory || [];
      this.EntityHistory = cache.EntityHistory || [];
      this.CriminaluserHistory = cache.CriminaluserHistory || [];
      this.ReportUserHistory = cache.ReportUserHistory || [];
      this.AdverseMediaReportHistory = cache.AdverseMediaReportHistory || [];
      this.AdverseMediaDetailHistory = cache.AdverseMediaDetailHistory || [];
      this.BatchScanHistory = cache.BatchScanHistory || [];
      this.noHistoryFound = !!cache.noHistoryFound;
      this.isLoading = false;
      return true;
    } catch (error) {
      return false;
    }
  }

  private buildAdverseMediaHistories() {
    // Adverse media history is stored in MongoDB; do not merge legacy Dynamo records.
    const allAdverseMediaHistory = this.mongoAdverseMediaHistory || [];
    this.AdverseMediaReportHistory = allAdverseMediaHistory.filter(
      history => history['type'] == 'MEDIA_REPORT',
    );
    this.AdverseMediaDetailHistory = allAdverseMediaHistory.filter(
      history => history['type'] == 'ADVERSE_MEDIA',
    );
  }

  private async refreshAdverseMediaHistory() {
    try {
      const mongoHistory = await this.dataService.getAdverseMediaHistory(
        this.userEmail,
      );
      this.mongoAdverseMediaHistory =
        (mongoHistory && mongoHistory.historyData) || [];
      this.buildAdverseMediaHistories();
      this.noHistoryFound =
        this.AlluserHistory.length <= 0 &&
        this.AdverseMediaReportHistory.length <= 0 &&
        this.AdverseMediaDetailHistory.length <= 0 &&
        this.BatchScanHistory.length <= 0;
      this.cacheHistoryState();
    } catch (error) {
      // Keep cached adverse media rows if refresh fails.
    }
  }

  async loadData() {
    const [dynamoHistory, mongoHistory, batchScanHistory] = await Promise.all([
      this.dataService.getUserHistory(this.userEmail).catch(() => null),
      this.dataService.getAdverseMediaHistory(this.userEmail).catch(() => ({
        historyData: [],
      })),
      this.dataService.getBatchScanReports(this.userEmail).catch(() => ({
        reports: [],
      })),
    ]);

    this.AlluserHistory =
      (dynamoHistory && dynamoHistory.historyData) || [];
    this.mongoAdverseMediaHistory =
      (mongoHistory && mongoHistory.historyData) || [];
    this.BatchScanHistory = (batchScanHistory && batchScanHistory.reports) || [];
  }

  formatBatchScanDate(value: string) {
    if (!value) {
      return "-";
    }
    const date = new Date(value);
    return isNaN(date.getTime()) ? value : date.toLocaleString();
  }

  getAdverseMediaDisplayHits(record: any): number | string {
    if (!record) {
      return "-";
    }

    const mediaPayload =
      record.adverseMediaData ||
      (record.news_exposures
        ? {
            timestamp: record.timestamp,
            news_exposures: record.news_exposures,
          }
        : null);

    if (mediaPayload && mediaPayload.news_exposures) {
      return getAdverseMediaTotalReturnedCount(mediaPayload);
    }

    if (record.totalHits != null) {
      return record.totalHits;
    }
    if (record.totalMatches != null) {
      return record.totalMatches;
    }
    return "-";
  }

  async viewBatchScanReport(report: any) {
    if (!report || !report.reportId) {
      return;
    }

    this.isLoadingBatchScanReport = true;
    try {
      const response = await this.dataService.getBatchScanReportDownloadUrl(
        report.reportId,
      );
      if (response && response.url) {
        window.open(response.url, "_blank");
      }
    } catch (error) {
      alert("Failed to open batch scan report.");
    } finally {
      this.isLoadingBatchScanReport = false;
    }
  }

  showReportDetails(data) {
    this.cacheHistoryState();
    markHistoryDetailNavigation();
    localStorage.setItem('historyData', JSON.stringify(data))
    console.log('historyData TTT', JSON.stringify(data))
    this.router.navigate(['/new-print-history'])
  }

  showCriminalDetails(data) {
    this.cacheHistoryState();
    markHistoryDetailNavigation();
    localStorage.setItem("data", JSON.stringify(data));
    this.router.navigate(["/result-criminal"]);
  }

  showPEPDetails(data) {
    this.cacheHistoryState();
    markHistoryDetailNavigation();
    localStorage.setItem('historyData', JSON.stringify(data))
    this.router.navigate(['/historyresult'])
  }

  showSanctionsDetails(data) {
    this.cacheHistoryState();
    markHistoryDetailNavigation();
    localStorage.setItem('historyData', JSON.stringify(data))
    this.router.navigate(['/sanction-historyresult'])
  }

  showEntityDetails(data) {
    this.cacheHistoryState();
    markHistoryDetailNavigation();
    localStorage.setItem('historyData', JSON.stringify(data))
    this.router.navigate(['/entity-historyresult'])
  }

  showNSLDetails(data) {
    this.cacheHistoryState();
    markHistoryDetailNavigation();
    localStorage.setItem('historyData', JSON.stringify(data))
    this.router.navigate(['/nsl-historyresult'])
  }

  showNSLEntityDetails(data) {
    this.cacheHistoryState();
    markHistoryDetailNavigation();
    localStorage.setItem('historyData', JSON.stringify(data))
    this.router.navigate(['/nsl-entity-historyresult'])
  }

  private hasFullAdverseMediaData(record: any): boolean {
    if (!record) {
      return false;
    }
    if (record.adverseMediaData && record.adverseMediaData.news_exposures) {
      return true;
    }
    return !!(record.news_exposures && Object.keys(record.news_exposures).length);
  }

  async showAdverseMediaDetails(data) {
    let record = data;

    if (record && record.historyId && !this.hasFullAdverseMediaData(record)) {
      this.isLoadingAdverseMediaDetail = true;
      try {
        record = await this.dataService.getAdverseMediaHistoryById(record.historyId);
      } catch (error) {
        alert('Failed to load adverse media record. Please try again.');
        return;
      } finally {
        this.isLoadingAdverseMediaDetail = false;
      }
    }

    this.cacheHistoryState();
    markHistoryDetailNavigation();

    if (record && record.type == 'MEDIA_REPORT') {
      localStorage.setItem('mediaReportHistoryData', JSON.stringify(record))
      if (record.hongKongDT) {
        localStorage.setItem('searchDateAndTime', record.hongKongDT)
      }
      this.router.navigate(['/new-print-media'])
      return
    }

    localStorage.removeItem('mediaReportHistoryData')
    const mediaData = record && record.adverseMediaData
      ? record.adverseMediaData
      : {
          timestamp: record && record.timestamp,
          news_exposures: record && record.news_exposures,
        }
    localStorage.setItem('adverseMediaData', JSON.stringify(mediaData))
    localStorage.setItem('adverseMediaSearchedName', (record && (record.searchedName || record.name)) || '')
    this.router.navigate(['/result-adverse-media'])
  }
}
